import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';

const BrandSortTypeSchema = z.enum(['LATEST', 'BRAND_NAME']);

const GetReverseProposalBrandsRequestSchema = z
  .object({
    sortType: BrandSortTypeSchema.optional(),
    page: z.number().min(1).optional(),
    size: z.number().min(1).max(100).optional(),
  })
  .describe('GetReverseProposalBrandsRequestSchema');

export type GetReverseProposalBrandsRequest = z.infer<typeof GetReverseProposalBrandsRequestSchema>;

const AgreedBrandItemSchema = z
  .object({
    brand: z.string(),
    brandName: z.string(),
    logoImage: z.string(),
  })
  .describe('AgreedBrandItemSchema');

const GetReverseProposalBrandsResponseDataSchema = z.object({
  list: z.array(AgreedBrandItemSchema),
});

const GetReverseProposalBrandsResponseSchema = createApiResponseSchema(
  GetReverseProposalBrandsResponseDataSchema,
);

export type GetReverseProposalBrandsResponse = z.infer<
  typeof GetReverseProposalBrandsResponseSchema
>;

export const getReverseProposalBrands = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetReverseProposalBrandsRequestSchema),
    async (params: GetReverseProposalBrandsRequest): Promise<GetReverseProposalBrandsResponse> =>
      executeStandardRequest(async () => {
        const response = await privateHttpClient.get<GetReverseProposalBrandsResponse>(
          urlJoin(campaignsApiPath.getReverseProposalBrands),
          params,
        );
        return response;
      }),
    validateApiResponse(GetReverseProposalBrandsResponseSchema),
  ),
);
